import { useRef, useMemo, useState, useEffect } from 'react';
import UAParser from 'ua-parser-js';

export function useUserAgentInfo() {
  const parser = useRef<UAParser>(new UAParser());

  const { version: browserVersion, name: browserName } = parser.current.getBrowser();
  const { version: osVersion, name: osName } = parser.current.getOS();
  const { type: deviceType, vendor: deviceVendor, model: deviceModel } = parser.current.getDevice();

  const type = useMemo(
    () => (deviceType ? [deviceType, deviceVendor, deviceModel].filter((t) => t && t).join(' ') : 'Laptop/Desktop'),
    [deviceType, deviceVendor, deviceModel],
  );
  const os = useMemo(() => [osName, osVersion].filter((t) => t && t).join(' '), [osName, osVersion]);

  const uaBrowser = useMemo(
    () => [browserName, browserVersion].filter((t) => t && t).join(' '),
    [browserName, browserVersion],
  );

  const [browser, setBrowser] = useState(uaBrowser);

  useEffect(() => {
    const uaData = (navigator as any).userAgentData;
    if (!uaData?.getHighEntropyValues) {
      return;
    }

    uaData
      .getHighEntropyValues(['fullVersionList'])
      .then((data: any) => {
        const brands: Array<{ brand: string; version: string }> = data.fullVersionList ?? [];
        const match =
          brands.find((b) => b.brand === 'Google Chrome' || b.brand === 'Microsoft Edge' || b.brand === 'Opera') ??
          brands.find((b) => b.brand === 'Chromium');

        if (match && browserName) {
          setBrowser(`${browserName} ${match.version}`);
        }
      })
      .catch(() => {
        // Client Hints unavailable or denied — ua-parser-js value already set
      });
  }, [browserName, uaBrowser]);

  return { type, os, browser };
}
